export default __webpack_public_path__ + "static/media/logo.cdefeca4.png";